import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PlayerService } from './player.service';
import { BulkUpdatePlayersRequest } from './player.type';
import { GOLD_RARITY_ID } from './player.constants';

@Component({
  selector: 'app-player-bulk-update-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './player-bulk-update-dialog.html',
})
export class PlayerBulkUpdateDialog implements OnInit {
  bulkUpdateForm: FormGroup;
  loading: boolean = false;

  qualityOptions = [
    { value: 'bronze', label: 'Bronze' },
    { value: 'silver', label: 'Silver' },
    { value: 'gold', label: 'Gold' },
    { value: 'special', label: 'Special' },
  ];

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<PlayerBulkUpdateDialog>,
    private playerService: PlayerService,
    private snackBar: MatSnackBar
  ) {
    this.bulkUpdateForm = this.createForm();
  }

  ngOnInit(): void {}

  createForm(): FormGroup {
    return this.fb.group({
      quality: ['gold', [Validators.required]],
      rarity_id: [GOLD_RARITY_ID, [Validators.required, Validators.min(0)]],
      overall: [80, [Validators.required, Validators.min(0), Validators.max(99)]],
      market_price: [750, [Validators.required, Validators.min(0)]],
    });
  }

  onSubmit(): void {
    if (this.bulkUpdateForm.invalid) {
      this.snackBar.open('Please fill in all required fields correctly', 'Close', {
        duration: 3000,
      });
      return;
    }

    this.loading = true;

    const formValue = this.bulkUpdateForm.value;
    const request: BulkUpdatePlayersRequest = {
      quality: formValue.quality,
      rarity_id: formValue.rarity_id,
      overall: formValue.overall,
      market_price: formValue.market_price,
    };

    this.playerService.bulkUpdatePlayers(request).subscribe({
      next: (response) => {
        this.snackBar.open(
          response.message || 'Players updated successfully',
          'Close',
          { duration: 5000 }
        );
        this.loading = false;
        this.dialogRef.close(true);
      },
      error: (error) => {
        console.error('Failed to bulk update players:', error);
        this.snackBar.open(
          error.error?.error || 'Error updating players',
          'Close',
          { duration: 5000 }
        );
        this.loading = false;
      },
    });
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
